import * as React from "react";
import { IDreamsState } from "../IDreamsState";
import { hashTagsService } from "motw_core/Services/HashTagsService";

export function EnergyFilterInfoText({ state }: { state: IDreamsState }) {
    const isHashTag = hashTagsService.IsWordHashTag(state.searchText);

    if (!isHashTag) {
        return null;
    }

    const hashTag = state.searchText;
    const isEnergyHashTag = hashTagsService.IsEnergyHashTag(hashTag);

    if (!isEnergyHashTag) {
        return null;
    }

    const numberOfDreams = state.dreamsdata.filter((dream) =>
        hashTagsService.DoesDreamHaveHashTag(dream, hashTag)
    ).length;

    if (numberOfDreams <= numberOfDreamsLimit) {
        return null;
    }

    return (
        <div style={{ background: "rgb(191 136 0 / 25%)", marginTop: `5px` }}>
            <span style={{ opacity: 0.5 }}>
                this energy hashtag has too many ({numberOfDreams}) dreams!
            </span>
        </div>
    );
}

const numberOfDreamsLimit = 15;
